<template>
  <!--card-form-->
  <div id="transaction-config-card" class="card cardlabel sticky-top align-top">
    <div class="expander" @click="isExpand = !isExpand">
      <h2>
        <span style="color: #003cff">{{ contract.get("symbol") }}</span> -
        Configuration
      </h2>
      <font-awesome-icon icon="fa-solid fa-chevron-down" :class="{ 'icon-rotate': isExpand === true }" />
    </div>
    <div v-if="isCopyTrading()" class="card-body" :class="{ 'is-expand': isExpand === true }">
      <div class="d-flex flex-wrap">
        <div class="col-lg-6 pe-lg-3">
          <div class="d-flex">
            <div class="" style="margin-right: 8px; margin-top: 3px">
              <h2 class="m-0">Buy</h2>
            </div>
          </div>
          <div class="d-flex flex-wrap mt-2">
            <div class="col-lg-6 pe-lg-3 col-sm-12 col-12">
              <div class="">
                <label class="form-label">{{ getNetwork().currency }} Amount<img class="ms-lg-2 pointer"
                    src="img/info-card.svg" onclick="Intercom('showArticle', 6208171)" /></label>
                <input v-model="config.buyAmount" type="text" class="form-control" placeholder="12" />
              </div>
            </div>
            <div class="col-lg-6 ps-lg-3 col-sm-12 col-12 mobile-mt">
              <div class="d-flex align-items-center dm">
                <input v-model="config.isBuyInstant" id="check" class="form-check-input" type="checkbox" value=""
                  aria-label="..." />
                <label class="me-2 m-0 ps-3" for="check">Buy Instant</label>
                <img class="ms-lg-2 pointer" src="img/info-card.svg" onclick="Intercom('showArticle', 6208167)" />
              </div>
              <div class="d-flex align-items-center dm mt-1">
                <input v-model="config.isBuySameAmount" id="check2" class="form-check-input" type="checkbox" value=""
                  aria-label="..." />
                <label class="me-2 m-0 ps-3" for="check2">Same Amount</label>
                <img class="ms-lg-2 pointer" src="img/info-card.svg" onclick="Intercom('showArticle', 6208171)" />
              </div>
              <div class="d-flex align-items-center dm mt-1">
                <input v-model="config.isBuyOnce" id="check3" class="form-check-input" type="checkbox" value=""
                  aria-label="..." />
                <label class="me-2 m-0 ps-3" for="check3">Buy Once</label>
                <img class="ms-lg-2 pointer" src="img/info-card.svg" onclick="Intercom('showArticle', 6208176)" />
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap mt-2">
            <div class="col-lg-6 pe-3">
              <div class="">
                <label class="form-label">Normal Gas Multiplier<img class="ms-lg-2 pointer" src="img/info-card.svg"
                    onclick="Intercom('showArticle', 6208167)" /></label>
                <input v-model="config.buyGasMultiplier" type="text" class="form-control" placeholder="0" />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="">
                <label class="form-label">Frontrun Gas Multiplier<img class="ms-lg-2 pointer" src="img/info-card.svg"
                    onclick="Intercom('showArticle', 6208167)" /></label>
                <input v-model="config.buyFastGasMultiplier" type="text" class="form-control" placeholder="1.5" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mobile-mt">
          <div class="d-flex" style="margin-top: 3px">
            <h2 class="m-0">Sell</h2>
          </div>
          <div class="d-flex flex-wrap mt-2">
            <div class="col-lg-12 pe-3">
              <div class="d-flex flex-wrap">
                <div class="col-lg-6 pe-3">
                  <div class="">
                    <label class="form-label">Threshold<img class="ms-lg-2 pointer" src="img/info-card.svg"
                        onclick="Intercom('showArticle', 6208182)" /></label>
                    <input v-model="config.sellThreshold" type="text" class="form-control" placeholder="0" />
                  </div>
                </div>
                <div class="col-lg-6 ps-lg-3 col-sm-12 col-12 mobile-mt">
                  <div class="d-flex align-items-center dm">
                    <input v-model="config.isSellOnWarn" id="checksellinstant" class="form-check-input" type="checkbox"
                      value="" aria-label="..." />
                    <label class="me-2 m-0 ps-3" for="checksellinstant">Sell Instant</label>
                    <img class="ms-lg-2 pointer" src="img/info-card.svg" onclick="Intercom('showArticle', 6208184)" />
                  </div>
                  <div class="d-flex align-items-center dm mt-3">
                    <input v-model="config.isSellSameAmount" id="checksameamount" class="form-check-input"
                      type="checkbox" value="" aria-label="..." />
                    <label class="me-2 m-0 ps-3" for="checksameamount">Same Amount</label>
                    <img class="ms-lg-2 pointer" src="img/info-card.svg" onclick="Intercom('showArticle', 6208193)" />
                  </div>
                </div>
              </div>
              <div class="d-flex flex-wrap mt-2">
                <div class="col-lg-6 pe-3">
                  <div class="">
                    <label class="form-label">Normal Gas Multiplier<img class="ms-lg-2 pointer" src="img/info-card.svg"
                        onclick="Intercom('showArticle', 6208184)" /></label>
                    <input v-model="config.sellGasMultiplier" type="text" class="form-control" placeholder="0" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="">
                    <label class="form-label">Frontrun Gas Multiplier<img class="ms-lg-2 pointer"
                        src="img/info-card.svg" onclick="Intercom('showArticle', 6208184)" /></label>
                    <input v-model="config.sellFastGasMultiplier" type="text" class="form-control" placeholder="1.5" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="card-body" :class="{ 'is-expand': isExpand === true }">
      <div class="d-flex flex-wrap">
        <div class="col-lg-6 pe-lg-3">
          <div class="d-flex">
            <div class="" style="margin-right: 8px; margin-top: 3px">
              <h2 class="m-0">Buy</h2>
            </div>
            <div class="col-lg-5 d-flex align-items-center" :style="getLevel().canSnipe() ? '' : 'visibility: hidden;'">
              <label class="form-label" style="margin-right: 6px !important; margin-top: 6px !important">On
                <img id="help-buy-on" class="pointer ms-lg-2" src="img/info-card.svg" data-toggle="tooltip"
                  data-placement="bottom" title="Trigger buy on this function"
                  onclick="Intercom('showArticle', 6020973)" />
              </label>
              <input style="margin-top: 0px" v-model="config.buyOn" type="text" class="form-control" placeholder="" />
            </div>
            <a v-if="canWatch" @click="handleWatch" data-mdb-placement="bottom" title="Watch" style="margin-left: 10px">
              <img v-if="isWatch" style="width: 30px; height: 30px" class="action-icon" src="img/unobserve.svg" />
              <img v-else style="width: 30px; height: 30px" class="action-icon" src="img/observe.svg" />
              <span v-if="isWatch">Watching...</span>
            </a>
          </div>
          <div class="d-flex flex-wrap mt-2">
            <div class="col-lg-6 pe-lg-3 col-sm-12 col-12">
              <div class="">
                <label class="form-label">{{ getNetwork().currency }} Amount<img class="ms-lg-2 pointer"
                    src="img/info-card.svg" onclick="Intercom('showArticle', 6021003)" /></label>
                <input v-model="config.buyAmount" type="text" class="form-control" placeholder="12" />
              </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-12">
              <div class="" v-if="!config.isOriginalRouter">
                <label class="form-label">Max Percent<img class="ms-lg-2 pointer" src="img/info-card.svg"
                    onclick="Intercom('showArticle', 6021003)" /></label>
                <input v-model="config.maxSupply" type="text" class="form-control" placeholder="0.75" />
              </div>
            </div>
          </div>
          <div v-if="getLevel().canSnipe()" class="d-flex flex-wrap mt-2">
            <div class="col-lg-6 pe-3">
              <div class="">
                <label class="form-label">Normal Gas Multiplier<img class="ms-lg-2 pointer" src="img/info-card.svg"
                    onclick="Intercom('showArticle', 6021015)" /></label>
                <input v-model="config.buyGasMultiplier" type="text" class="form-control" placeholder="0" />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="">
                <label class="form-label">Gas Limit<img class="ms-lg-2 pointer" src="img/info-card.svg"
                    onclick="Intercom('showArticle', 6208153)" /></label>
                <input v-model="config.gasLimitETH" type="text" class="form-control" placeholder="1.5" />
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap mt-2">
            <div class="col-lg-6 pe-3">
              <div class="">
                <!-- <label class="form-label">Initial Pool ETH Amount</label>
                <input
                  v-model="config.initialPoolETHAmount"
                  type="text"
                  class="form-control"
                  placeholder="1"
                /> -->
                <label class="form-label">Min</label>
                <input v-model="config.minDisperseAmount" type="text" class="form-control" placeholder="0.1" />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="">
                <!-- <label class="form-label">Initial Pool Token Percent</label>
                <input
                  v-model="config.initialPoolTokenPercent"
                  type="text"
                  class="form-control"
                  placeholder="100"
                /> -->
                <label class="form-label">Max</label>
                <input v-model="config.maxDisperseAmount" type="text" class="form-control" placeholder="0.35" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mobile-mt">
          <div class="d-flex" style="height: 30px; margin-top: 3px">
            <h2 class="m-0">Sell</h2>
          </div>
          <div class="d-flex flex-wrap mt-2">
            <div class="col-lg-6 pe-lg-3 col-sm-12 col-12">
              <div class="">
                <label class="form-label">Account’s Percent<img class="ms-lg-2 pointer" src="img/info-card.svg"
                    onclick="Intercom('showArticle', 6021011)" /></label>
                <input v-model="config.sellPercent" type="text" class="form-control" placeholder="100" />
              </div>
            </div>
            <div class="col-lg-6 ps-lg-3 col-sm-12 col-12 mobile-mt" v-if="getLevel().canSnipe()">
              <div class="d-flex align-items-center dm">
                <input v-model="config.isBuyInstant" id="check" class="form-check-input" type="checkbox" value=""
                  aria-label="..." />
                <label class="me-2 m-0 ps-3" for="check">{{
                  config.isBuyInstant ? "Buy Instant" : "Blocks: "
                }}</label>
                <input v-if="!config.isBuyInstant" v-model="config.blocks" style="
                    width: 30px;
                    height: 30px;
                    margin-top: 0px;
                    margin-left: 5px;
                  " class="form-check-input" />
                <img class="ms-lg-2 pointer" src="img/info-card.svg" onclick="Intercom('showArticle', 6021015)" />
              </div>
              <div class="d-flex align-items-center dm mt-3">
                <input v-model="config.isSellOnWarn" id="check2" class="form-check-input" type="checkbox" value=""
                  aria-label="..." />
                <label class="me-2 m-0 ps-3" for="check2">Sell on Warn</label>
                <img class="ms-lg-2 pointer" src="img/info-card.svg" onclick="Intercom('showArticle', 6021020)" />
              </div>
            </div>
          </div>
          <div v-if="getLevel().canSnipe()" class="d-flex flex-wrap mt-2">
            <div class="col-lg-12 pe-3">
              <div class="d-flex flex-wrap">
                <div class="col-lg-6 pe-3">
                  <div class="">
                    <label class="form-label">Normal Gas Multiplier<img class="ms-lg-2 pointer" src="img/info-card.svg"
                        onclick="Intercom('showArticle', 6021020)" /></label>
                    <input v-model="config.sellGasMultiplier" type="text" class="form-control" placeholder="0" />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="">
                    <label class="form-label">Frontrun Gas Multiplier<img class="ms-lg-2 pointer"
                        src="img/info-card.svg" onclick="Intercom('showArticle', 6021020)" /></label>
                    <input v-model="config.sellFastGasMultiplier" type="text" class="form-control" placeholder="1.5" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex mt-2">
            <div class="col-lg-2">
              <div class="d-flex mt-2 justify-content-center align-items-center" style="flex-direction: column">
                <label class="form-label">Website</label>
                <input style="" class="form-check-input" type="checkbox" :checked="config.isWebsite"
                  @click="toggleWebsite" aria-label="..." />
              </div>
            </div>
            <div class="col-lg-2">
              <div class="d-flex mt-2 justify-content-center align-items-center" style="flex-direction: column">
                <label class="form-label">Rug</label>
                <input style="" class="form-check-input" type="checkbox" :checked="config.isRugLaunch"
                  @click="toggleRugLaunch" aria-label="..." />
              </div>
            </div>
            <div class="d-flex mt-2 justify-content-center align-items-center gap-3" style="flex-direction: row">
              <div class="d-flex justify-content-center align-items-center" style="flex-direction: row">
                <label class="form-label">MultiSel</label>
                <!-- <input style="" class="form-check-input" type="checkbox" :checked="config.isMultiSelection"
                  @click="toggleMultiSelection" aria-label="..." /> -->
                <input style="margin-top: 0px" v-model="config.multiSelectionCnt" type="text" class="form-control"
                placeholder="" />
              </div>
              <!-- <div class="col-lg-2">
                <input style="margin-top: 0px" v-model="config.multiSelectionCnt" type="text" class="form-control"
                  placeholder="" />
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <hr />
      <div class="d-flex flex-wrap align-items-center mobile-gap">
        <div class="col-lg-6">
          <div class="d-flex gap-2">
            <!-- <div class="col-lg-6">
              <h2 class="m-0">Cancel</h2>
            </div> -->
            <div class="col-lg-6 d-flex align-items-center">
              <!-- <label
                class="form-label"
                style="margin-right: 6px !important; margin-top: 3px !important"
                >Gas Multiplier</label
              >
              <input
                style="margin-top: -5px"
                v-model="config.cancelGasMultiplier"
                type="text"
                class="form-control"
                placeholder=""
              /> -->
              <label class="form-label" style="
                  margin-right: 6px !important;
                  margin-top: 3px !important;
                  font-size: medium;
                  font-weight: 400;
                  color: blue;
                ">BUY(
                <span style="color: black">{{
                  autoBuyTimer != 0
                    ? Math.floor((autoBuyTimer - nowTimer) / 1000)
                    : "0"
                }}</span>)</label>
              <input style="margin-top: -5px" v-model="config.autoBuyInterval" type="text" class="form-control"
                placeholder="" />
            </div>
            <div class="col-lg-6 d-flex align-items-center">
              <label class="form-label" style="
                  margin-right: 6px !important;
                  margin-top: 3px !important;
                  font-size: medium;
                  font-weight: 400;
                  color: red;
                ">SELL(
                <span style="color: black">{{
                  autoSellTimer != 0
                    ? Math.floor((autoSellTimer - nowTimer) / 1000)
                    : "0"
                }}</span>)</label>
              <input style="margin-top: -5px" v-model="config.autoSellInterval" type="text" class="form-control"
                placeholder="" />
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div v-if="true || getLevel().canSnipe()" class="d-flex flex-wrap pe-3">
            <!-- <div class="col-lg-6">
              <div
                class="button-text d-flex justify-content-center align-items-center"
                style="margin-top: -4px"
              >
                 <a
                  style="font-size: 12px"
                  @click="getSelector()"
                  class="btn-theme"
                  >Get Selector</a
                > 
              </div>
            </div> -->
            <div class="d-flex align-items-center" style="margin-left: 30px">
              <!-- <input
                style="margin-top: -5px"
                v-model="config.bundleTip"
                type="text"
                class="form-control"
                placeholder=""
              /> -->
              <label class="form-label" style="
                  margin-right: 6px !important;
                  margin-top: 3px !important;
                  font-size: medium;
                  font-weight: 400;
                  color: red;
                ">Recipient</label>
              <input class="form-control" style="margin-top: -5px" v-model="config.autosellRecipientAddress" type="text"
                placeholder="" />
            </div>
          </div>
        </div>
      </div>
      <hr />

      <div class="d-flex align-items-center" style="margin-right: 8px; margin-bottom: 16px; gap: 5px">
        <input style="margin-top: 0px" class="form-check-input" type="checkbox" :checked="config.isAutoBuy"
          @click="toggleAutoBuy" aria-label="..." />
        <label class="form-label" style="font-size: medium; font-weight: 400; color: blue">AutoBuy</label><br />
        <input style="margin-top: 0px" class="form-check-input" type="checkbox" :checked="config.isAutoSell"
          @click="toggleAutoSell" aria-label="..." />
        <label class="form-label" style="font-size: medium; font-weight: 400; color: red">AutoSell</label><br />
        <!-- <h2 class="m-0" style="margin-right: 20px">Flash Actions</h2>
        <div
          class="button-text d-flex justify-content-center align-items-center"
          style="margin-top: -4px"
        >
          <a
            v-if="!this.pending.mev"
            style="font-size: 12px; width: 80px"
            @click="onMev('mev')"
            class="btn-theme"
            >MEV</a
          >
          <img v-else class="loading-icon" src="img/spinner.svg" />
        </div> -->
        <div>
          <!-- <input
            style="margin-top: 0px"
            v-model="config.setTaxWalletFuncName"
            type="text"
            class="form-control"
            placeholder=""
          /> -->
        </div>
        <div class="d-flex align-items-center">
          <div style="margin-right: 12px; font-weight: 700">100% Sell:</div>
          <input class="form-check-input" type="checkbox" :checked="config.isPercent" @click="togglePercent"
            aria-label="..." style="min-width: 20px; min-height: 20px" />
        </div>
        <div class="d-flex justify-content-around" style="flex: 1 !important">
          <div class="button-text d-flex justify-content-center align-items-center"
            style="margin-top: -4px; width: 100%">
            <a v-if="!this.pending.mixtrade" style="
                font-size: 12px;
                width: 100%;
                background-color: rgb(180, 80, 80);
              " @click="onLaunch('mixtrade', false, true)" class="btn-theme">MIXED</a>
            <img v-else class="loading-icon" src="img/spinner.svg" />
          </div>
          <div class="button-text d-flex justify-content-center align-items-center"
            style="margin-top: -4px; width: 100%">
            <a v-if="!this.pending.multibuy" style="font-size: 12px; width: 100%" @click="onLaunch('multibuy', false)"
              class="btn-theme">MULTI BUY</a>
            <img v-else class="loading-icon" src="img/spinner.svg" />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-start align-items-center">
        <div class="col-lg-2 pe-lg-1">
          <!-- <label class="form-label"
            >Tip<img
              class="ms-lg-2 pointer"
              src="img/info-card.svg"
              onclick="Intercom('showArticle', 6021003)"
          /></label>
          <input
            style="margin-top: 0px"
            v-model="config.tipAmount"
            type="text"
            class="form-control"
            placeholder=""
          /> -->
          <label class="form-label">Target Pool</label>
          <input style="margin-top: 0px" v-model="config.targetPoolSize" type="text" class="form-control"
            placeholder="" />
        </div>
        <div class="col-lg-2 pe-lg-1">
          <label class="form-label">Min</label>
          <input style="margin-top: 0px" v-model="config.minAmount" type="text" class="form-control" placeholder="" />
        </div>
        <div class="col-lg-2 pe-lg-1">
          <label class="form-label">Max</label>
          <input style="margin-top: 0px" v-model="config.maxAmount" type="text" class="form-control" placeholder="" />
        </div>

        <div class="col-lg-1 pe-lg-1">
          <label class="form-label">GasPlus</label>
          <input style="margin-top: 0px" v-model="config.basePerGas" type="text" class="form-control" placeholder="" />
        </div>

        <div class="pe-lg-1">
          <label class="form-label">MA</label><br />
          <!-- <input
            style="margin-top: 0px"
            class="form-check-input"
            type="checkbox"
            :checked="config.isWhale"
            @click="toggleWhale"
            aria-label="..."
          /> -->
          <input style="margin-top: 0px" class="form-check-input" type="checkbox" :checked="config.isMassiveBB"
            @click="toggleMassiveBB" aria-label="..." />
        </div>

        <div class="pe-lg-1">
          <label class="form-label">AMX</label><br />
          <!-- <input
            style="margin-top: 0px"
            class="form-check-input"
            type="checkbox"
            :checked="config.isWhale"
            @click="toggleWhale"
            aria-label="..."
          /> -->
          <input style="margin-top: 0px" class="form-check-input" type="checkbox" :checked="config.isMixedAutoSell"
            @click="toggleMixedAutoSell" aria-label="..." />
        </div>

        <div class="col-lg-1 pe-lg-1">
          <label class="form-label">SellBP</label>
          <input style="margin-top: 0px" v-model="config.autoSellBasePercent" type="text" class="form-control"
            placeholder="" />
        </div>

        <div class="col-lg-1 pe-lg-1">
          <label class="form-label" style="margin: 0">SellETH</label>
          <input style="margin-top: 0px" v-model="config.sellETHAmount" type="text" class="form-control"
            placeholder="" />
        </div>
        <div class="col-lg-1 pe-lg-1">
          <label class="form-label" style="margin: 0"> SellCnt </label>
          <vs-select :placeholder="'2'" v-model="autoSellCount" border-color="#bdbdbd"
            style="font-size: 12px; width: 120%">
            <vs-option v-for="(autoSellCount, autoSellCountIndex) in autoSellCountList"
              :key="'autoSellCount-' + autoSellCountIndex" :label="autoSellCount.toString()" :value="autoSellCount">
              {{ autoSellCount }}
            </vs-option>
          </vs-select>
        </div>

        <div class="col-lg-1 pe-lg-1">
          <div style="position: relative">
            <label class="form-label"> BuyCnt </label>
            <vs-select :placeholder="'4'" v-model="autobuyCount" border-color="#bdbdbd"
              style="font-size: 12px; width: 120%">
              <!-- Adjust width here -->
              <vs-option v-for="(autobuyCount, autobuyCountIndex) in autobuyCountList"
                :key="'autobuyCount-' + autobuyCountIndex" :label="autobuyCount.toString()" :value="autobuyCount">
                {{ autobuyCount }}
              </vs-option>
            </vs-select>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-end" style="margin-top: 16px; gap: 3px">
        <div class="col-lg-2">
          <label class="form-label" style="margin: 0px 8px 0px 0px !important">DPK</label>
          <input style="margin-top: 0px" v-model="config.dpk" type="text" class="form-control" placeholder="" />
        </div>
        <div class="col-lg-2">
          <label class="form-label" style="margin: 0px 8px 0px 0px !important">Enable Proc</label>
          <input style="margin-top: 0px" v-model="config.enableProc" type="text" class="form-control" placeholder="" />
        </div>
        <div class="col-lg-2" style="height: 35.52px">
          <div class="button-text d-flex justify-content-center align-items-center" style="height: 100%">
            <a v-if="!this.pending.enable" style="font-size: 12px" @click="onLaunch('enable', true)"
              class="btn-theme d-flex justify-content-center align-items-center">ENABLE</a>
            <img v-else class="loading-icon" src="img/spinner.svg" />
          </div>
        </div>

        <div class="col-lg-6 d-flex justify-content-around" style="flex: 1 !important; height: 35.52px; gap: 0.5rem">
          <div class="d-flex justify-content-center" style="flex: 3 !important; height: 100%; gap: 0.5rem">
            <div class="button-text d-flex justify-content-center align-items-center" style="flex: 1; height: 100%">
              <a :style="{
                fontSize: '12px',
                width: '100%',
                backgroundColor: 'coral',
                color: isAutoPlaying ? 'red' : '',
                userSelect: 'none',
                height: '100%',
                margin: '0 !important',
                fontSize: '20px',
              }" @click="onAutoPlay" class="btn-theme">
                {{ this.isAutoPlaying ? "⏯️" : "▶️" }}
              </a>
            </div>
            <div class="button-text d-flex justify-content-center align-items-center" style="flex: 1; height: 100%">
              <a v-if="!this.pending.autofixedSell" style="
                  font-size: 12px;
                  background-color: #2e8b57;
                  width: 100%;
                  height: 100%;
                  margin: 0 !important;
                " @click="
                  handleAutoSell()
                  " class="btn-theme">AFXSELL</a>
              <img v-else class="loading-icon" src="img/spinner.svg" />
            </div>
            <div class="button-text d-flex justify-content-center align-items-center"
              style="width: 100%; flex: 1; height: 100%">
              <a v-if="!this.pending.autosell" style="
                  font-size: 12px;
                  background-color: #6d2323;
                  width: 100%;
                  height: 100%;
                  margin: 0 !important;
                " @click="
                  onAutoSell('autosell', autoSellCount, config.sellETHAmount)
                  " class="btn-theme">ASELL</a>
              <img v-else class="loading-icon" src="img/spinner.svg" />
            </div>
          </div>
          <!-- <div class="col-lg-2 d-flex justify-content-around" style=""> -->
          <div class="button-text d-flex justify-content-center align-items-center" style="flex: 2; height: 100%">
            <a v-if="!this.pending.autobuy" style="
                font-size: 12px;
                width: 100%;
                height: 100%;
                margin: 0 !important;
              " @click="onAutoBuy('autobuy', autobuyCount)" class="btn-theme">ABUY</a>
            <img v-else class="loading-icon" src="img/spinner.svg" />
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from "vuex";
import Listener from "@/helpers/Listener";
import Web3 from "web3";
import Ethers from "@/helpers/Ethers";
import Web3Helper from "@/helpers/Web3";
import axios from "axios";
import { ethers } from "ethers";
import Config from "@/config";
import CopyTrade from "@/helpers/CopyTrade";
import whitelists from "../whitelist.json";
import Utils from "@/helpers/Utils";
// import config from "../config";
import { utils } from "ethers";
// Parameters
const MIN_INTERVAL = 24 * 1000; // 24 seconds
const MAX_INTERVAL = 300 * 1000; // 5 minutes
const GAS_PRICE_HISTORY = []; // Store recent gas prices
const HISTORY_SIZE = 5; // Smaller history for responsiveness
const TARGET_INTERVALS = [
  24, 48, 60, 90, 120, 150, 180, 210, 240, 270, 300,
].map((s) => s * 1000); // ms

const TARGET_POOL_SIZE_LIST = [1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,8,9,10,11,12,15,17,19,21,23,24, 30, 35, 40, 45, 50, 55, 60];
export default {
  name: "TransactionConfig",
  components: {},
  computed: {
    ...mapGetters({
      config: "transactions/config",
      contract: "contracts/active",
      accounts: "accounts/list",
    }),
    canWatch() {
      return (
        this.contract &&
        this.getLevel().canSnipe() &&
        !this.getNetwork().cantWatch
      );
    },
  },
  watch: {
    contract() {
      if (this.isWatch) {
        Listener.stop();
        this.isWatch = false;
      }
    },
  },

  async mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
    this.autoTradeTimer = setInterval(this.autoTrade, 1000);
    this.fetchPoolWETHTimer = setInterval(this.refreshPoolWETHAmount, 5000);
    if (this.isAutoPlaying) await this.startBotBBTimer();
  },

  beforeDestroy() {
    Listener.stop();
    window.removeEventListener("keydown", this.handleKeyDown);
    clearInterval(this.autoTradeTimer);
    clearInterval(this.autoPlayingTimer);
    // TODO: remove socket
  },
  methods: {
    ...mapActions({
      approve: "accounts/approve",
      allowance: "accounts/allowance",
      sell: "accounts/sell",
      getTxConfig: "transactions/getConfig",
    }),
    async refreshPoolWETHAmount() {
      const currentPoolSize = await this.getCurrentPoolWETHAmount();
      this.config.currentTokenPoolETH = currentPoolSize;
    },
    async startBotBBTimer() {
      if (this.autoPlayingTimer) clearInterval(this.autoPlayingTimer);
      // Initialize auto-playing state
      let gasPrice = await Web3Helper.getGasPrice();
      let gasPriceInGwei = parseFloat(
        Number(ethers.utils.formatUnits(gasPrice, 9)).toFixed(2)
      );
      GAS_PRICE_HISTORY.push(gasPriceInGwei);
      if (GAS_PRICE_HISTORY.length > HISTORY_SIZE) {
        GAS_PRICE_HISTORY.shift(); // Keep only the last 10 gas prices
      }

      let avgGasPrice = this.calculateMovingAverage(GAS_PRICE_HISTORY);
      // Recalculate interval
      let currentInterval = this.calculateInterval(
        avgGasPrice || gasPriceInGwei
      );
      console.log(
        `Initial gas price: ${gasPriceInGwei} Gwei, Average: ${avgGasPrice} Gwei , Interval: ${currentInterval} ms`
      );
      const timerHandler = async () => {
        if (this.isAutoPlaying) {
          gasPrice = await Web3Helper.getGasPrice();
          // Fetch the latest gas price
          gasPriceInGwei = parseFloat(
            Number(ethers.utils.formatUnits(gasPrice, 9)).toFixed(2)
          );
          GAS_PRICE_HISTORY.push(gasPriceInGwei);
          if (GAS_PRICE_HISTORY.length > HISTORY_SIZE) {
            GAS_PRICE_HISTORY.shift(); // Keep only the last 10 gas prices
          }

          avgGasPrice = this.calculateMovingAverage(GAS_PRICE_HISTORY);
          // Recalculate interval
          currentInterval = this.calculateInterval(
            avgGasPrice || gasPriceInGwei
          );

          // console.log(
          //   `Auto-playing started with interval: ${currentInterval} ms`
          // );
          // console.log(`Gas Price History: ${GAS_PRICE_HISTORY.join(", ")}`);
          // console.log(`Average Gas Price: ${avgGasPrice} Gwei`);
          // console.log(`Bot Interval : ${this.config.botInterval}ms`);
          this.handleAutoPlaying();
        }
      };

      timerHandler();
      this.autoPlayingTimer = setInterval(timerHandler, currentInterval);
    },
    generateRandomAmount(min = 0, max = 1, steepness = 3) {
      const random = Math.random();
      const normalized = -Math.log(1 - random) / steepness;
      const range = max - min;
      const amount = min + range * normalized;
      return Math.min(max, Math.max(min, Number(amount.toFixed(2))));
    },
    async autoTrade() {
      const now = Date.now();
      this.nowTimer = now;
      const currentPoolSize = await this.getCurrentPoolWETHAmount();

      if (currentPoolSize <= 1) {
        return;
      }

      const ethBalanceOfFirstAcc = parseFloat(
        this.formatBalance(this.accounts[1].balance)
      );
      
      if (this.config.isAutoBuy) {
        console.log("IS AUTO BUY");
        if (this.autoBuyTimer == 0)
          this.autoBuyTimer =
            now +
            Math.floor(
              this.config.autoBuyInterval * 1000 * (Math.random() * 0.4 + 0.8)
            );
        if (now > this.autoBuyTimer) {
          console.log("AUTO BUY PROCESS");
          this.onAutoBuy("autobuy", this.autobuyCount);
          console.log('isAutoDeposit:', this.isAutoDeposit);
          console.log('ethBalanceOfFirstAcc:', ethBalanceOfFirstAcc);
          if (!this.isAutoDeposit && ethBalanceOfFirstAcc >= 3.1)
            await this.handleAutoDeposit();
          this.autoBuyTimer =
            now +
            Math.floor(
              this.config.autoBuyInterval * 1000 * (Math.random() * 0.4 + 0.8)
            );
        }
      } else this.autoBuyTimer = 0;
      if (this.config.isAutoSell) {
        if (this.autoSellTimer == 0)
          this.autoSellTimer =
            now +
            Math.floor(
              this.config.autoSellInterval * 1000 * (Math.random() * 0.4 + 0.8)
            );
        if (now > this.autoSellTimer) {
          if (this.config.isMassiveBB || this.config.isMixedAutoSell) this.handleAutoSell();
          else
            this.onAutoSell(
              "autosell",
              this.config.autoSellCount,
              this.config.sellETHAmount
            );
          this.autoSellTimer =
            now +
            Math.floor(
              this.config.autoSellInterval * 1000 * (Math.random() * 0.4 + 0.8)
            );
        }
      } else this.autoSellTimer = 0;
    },

    async validateInput(event) {
      const value = event.target.value;
      // Regular expression: only allow digits
      const regex = /^\d*$/;

      if (!regex.test(value)) {
        this.config.botInterval = 24000; // Default to 24 seconds
        this.$toast.error("Invalid input! Only digits are allowed.", {
          position: "top-right",
          timeout: 2000,
          closeOnClick: true,
        });
        return;
      }

      const numericValue = parseInt(value, 10);
      if (value && numericValue < 10000) {
        this.config.botInterval = 24000; // Default to 24 seconds
        this.$toast.error(
          "Invalid input! Interval must be at least 10 seconds.",
          {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          }
        );
      } else if (value) {
        this.config.botInterval = numericValue;
        if (this.isAutoPlaying) await this.startBotBBTimer();
      }
    },
    getTotalBalance() {
      let total = 0;

      this.accounts.map((account) => {
        total += account.balance ? parseFloat(account.balance) : 0;
      });
      return this.formatBalance(total);
    },
    async getCurrentPoolWETHAmount() {
      const rpc =
        "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba";

      const provider = new ethers.providers.JsonRpcProvider({
        url: rpc,
      });

      const factoryAddr = "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f";
      const wethAddr = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"; // change this on main
      const tokenA = wethAddr; // Address of token A
      const tokenB = this.$route.params.address; // Address of token B
      if (!tokenB) return 0;
      // Ensure tokenA < tokenB
      const [token0, token1] =
        tokenA.toLowerCase() < tokenB.toLowerCase()
          ? [tokenA, tokenB]
          : [tokenB, tokenA];

      // const deadAddr = "0x000000000000000000000000000000000000dEaD";

      const initCodeHash =
        "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f";

      const pairAddress = ethers.utils.getCreate2Address(
        factoryAddr,
        ethers.utils.solidityKeccak256(
          ["bytes"],
          [ethers.utils.solidityPack(["address", "address"], [token0, token1])]
        ),
        initCodeHash
      );

      // console.log("Pair Address:", pairAddress);
      // const pairContract = Web3Helper.getUniswapV2PairContract(pairAddress);
      // Get WETH balance in the pair by calling balanceOf on the WETH contract
      const wethContract = new ethers.Contract(
        wethAddr,
        [
          // Minimal ABI for balanceOf
          "function balanceOf(address owner) view returns (uint256)",
        ],
        provider
      );
      const wethBalance = await wethContract.balanceOf(pairAddress);

      const currentPoolSize = parseFloat(ethers.utils.formatEther(wethBalance));

      return currentPoolSize;
    },
    // Calculate moving average of gas prices
    calculateMovingAverage(prices) {
      if (prices.length === 0) return null;
      const sum = prices.reduce((acc, price) => acc + price, 0);
      return sum / prices.length;
    },

    // Round interval to nearest target
    roundToTargetInterval(interval) {
      return TARGET_INTERVALS.reduce((prev, curr) =>
        Math.abs(curr - interval) < Math.abs(prev - interval) ? curr : prev
      );
    },

    roundToTargetPoolSizeList(targetPoolSize) {
      return TARGET_POOL_SIZE_LIST.reduce((prev, curr) =>
        Math.abs(curr - targetPoolSize) < Math.abs(prev - targetPoolSize)
          ? curr
          : prev
      );
    },
    // Calculate dynamic interval
    calculateInterval(gasPriceInGwei) {
      let interval;
      if (gasPriceInGwei <= 0.6) {
        // Constant 24 seconds for 0.2–0.6 Gwei
        interval = 24 * 1000;
      } else if (gasPriceInGwei <= 1) {
        // Linear interpolation: 36s at 0.6 Gwei, 48s at 1 Gwei
        interval =
          36000 + ((48000 - 36000) * (gasPriceInGwei - 0.6)) / (1 - 0.6);
      } else if (gasPriceInGwei <= 1.5) {
        // Linear interpolation: 36s at 1 Gwei, 48s at 1.5 Gwei
        interval = 48000 + ((60000 - 48000) * (gasPriceInGwei - 1)) / (1.5 - 1);
      } else if (gasPriceInGwei <= 5) {
        // Linear interpolation: 60s at 2 Gwei, 150s at 5 Gwei
        interval = 60000 + ((150000 - 60000) * (gasPriceInGwei - 2)) / (5 - 2);
      } else {
        // Cap at 300 seconds for >5 Gwei
        interval = 300 * 1000;
      }
      return Math.max(
        MIN_INTERVAL,
        Math.min(MAX_INTERVAL, this.roundToTargetInterval(interval))
      );
    },

    getBestDistribution(totalSum, numAccounts, step = 0.1, maxRange = 3) {
      // Validate inputs
      // if (
      //   numAccounts <= 0 ||
      //   totalSum < 0 ||
      //   !Number.isFinite(totalSum) ||
      //   !Number.isInteger(numAccounts)
      // ) {
      //   return {
      //     distribution: [],
      //     recommendation:
      //       "Invalid input: Total sum must be non-negative, number of accounts must be positive, and inputs must be valid numbers.",
      //   };
      // }

      // Convert total sum to integer units (step = 0.1 -> precision = 10)
      const precision = 1 / step;
      const totalUnits = Math.round(totalSum * precision);

      // Check if total sum is compatible with step size
      if (totalUnits % 1 !== 0) {
        return {
          distribution: [],
          // recommendation: `Invalid input: Total sum (${totalSum}) must be a multiple of step size (${step}).`,
        };
      }

      // Calculate base amount and remainder
      const baseUnits = Math.floor(totalUnits / numAccounts);
      const remainder = totalUnits % numAccounts;

      // Initialize distribution
      const distributionUnits = new Array(numAccounts).fill(baseUnits);
      for (let i = 0; i < remainder; i++) {
        distributionUnits[i] += 1;
      }

      // Adjust to target pattern: two low (e.g., 2.5), three medium (e.g., 3.5), one high (e.g., 5.5)
      if (numAccounts >= 4) {
        let lowCount = Math.min(2, Math.floor(numAccounts / 3)); // Two low values
        let highCount = 1; // One high value
        let mediumCount = numAccounts - lowCount - highCount; // Remaining medium

        // Ensure enough non-zero accounts for low values
        let availableLow = distributionUnits.filter((x) => x > 0).length;
        lowCount = Math.min(lowCount, availableLow);

        // Calculate target low and high values (inspired by [0.5, 1.5, 2.5, 0.5])
        const baseFloat = baseUnits / precision;
        const lowValue = Math.max(0.1, baseFloat - 1); // e.g., 2.5 if base=3.5
        const highValue = baseFloat + 2; // e.g., 5.5
        const mediumValue = baseFloat; // e.g., 3.5

        // Convert to units
        const lowUnits = Math.round(lowValue * precision);
        const highUnits = Math.round(highValue * precision);
        const mediumUnits = Math.round(mediumValue * precision);

        // Initialize new distribution
        let newDistributionUnits = [];
        let currentSumUnits = 0;

        // Assign low values
        for (let i = 0; i < lowCount; i++) {
          newDistributionUnits.push(lowUnits);
          currentSumUnits += lowUnits;
        }
        // Assign high value
        newDistributionUnits.push(highUnits);
        currentSumUnits += highUnits;
        // Assign medium values
        for (let i = 0; i < mediumCount; i++) {
          newDistributionUnits.push(mediumUnits);
          currentSumUnits += mediumUnits;
        }

        // Adjust to match total sum
        let diffUnits = totalUnits - currentSumUnits;
        if (diffUnits !== 0 && newDistributionUnits[numAccounts - 1] >= 0) {
          newDistributionUnits[numAccounts - 1] += diffUnits; // Adjust high value
        }

        // Use new distribution if valid
        const newDistribution = newDistributionUnits
          .map((units) => (units / precision).toFixed(1))
          .map(Number);
        const newSum = newDistribution.reduce((sum, val) => sum + val, 0);
        const newMax = Math.max(...newDistribution);
        const newMin = Math.min(...newDistribution);
        const newRange = newMax - newMin;

        if (
          Math.abs(newSum - totalSum) < 0.0001 &&
          newRange <= maxRange &&
          newDistribution.every((x) => x >= 0)
        ) {
          return {
            distribution: newDistribution,
            // recommendation:
            //   `Recommended distribution: ${JSON.stringify(newDistribution)}. ` +
            //   `This distribution sums to ${newSum.toFixed(
            //     1
            //   )} and has a range of ${newRange.toFixed(1)} ` +
            //   `(max: ${newMax.toFixed(1)}, min: ${newMin.toFixed(
            //     1
            //   )}), with amounts in multiples of ${step}. ` +
            //   `It follows a low-medium-high pattern (inspired by [0.5, 1.5, 2.5, 0.5]) ` +
            //   `while keeping the range ≤ ${maxRange}. Ideal average per account: ${(
            //     totalSum / numAccounts
            //   ).toFixed(2)}.`,
          };
        }
      }

      // Fallback: Simpler distribution
      const fallback = distributionUnits
        .map((units) => (units / precision).toFixed(1))
        .map(Number);
      const fallbackSum = fallback.reduce((sum, val) => sum + val, 0);
      const fallbackMax = Math.max(...fallback);
      const fallbackMin = Math.min(...fallback);
      const fallbackRange = fallbackMax - fallbackMin;

      if (
        Math.abs(fallbackSum - totalSum) < 0.0001 &&
        fallbackRange <= maxRange
      ) {
        return {
          distribution: fallback,
          // recommendation:
          //   `Recommended distribution: ${JSON.stringify(fallback)}. ` +
          //   `This distribution sums to ${fallbackSum.toFixed(
          //     1
          //   )} and has a range of ${fallbackRange.toFixed(1)} ` +
          //   `(max: ${fallbackMax.toFixed(1)}, min: ${fallbackMin.toFixed(
          //     1
          //   )}), with amounts in multiples of ${step}. ` +
          //   `The desired pattern could not be achieved, so a simpler balanced distribution is provided. ` +
          //   `Ideal average per account: ${(totalSum / numAccounts).toFixed(
          //     2
          //   )}.`,
        };
      }

      return {
        distribution: [],
        // recommendation: `No distribution found with sum ${totalSum} and range ≤ ${maxRange}. Try increasing maxRange or adjusting total sum.`,
      };
    },

    isCopyTrading() {
      return this.$route.name == "CopyTrading";
    },
    formatBalance(balance, decimals) {
      if (!balance) {
        return "_";
      }
      return Utils.formatBalance(balance, decimals, 4);
    },
    getLevel() {
      return Web3Helper.getLevel();
    },
    getNetwork() {
      return Web3Helper.getNetwork();
    },

    getSelector() {
      if (this.selector.substr(0, 2) != "0x") {
        let func = this.selector;
        func = func.replace(/(\r\n|\n|\r)/gm, "");
        func = func.split("(");

        const nameSplits = func[0].split(" ");
        const name = nameSplits[nameSplits.length - 1];

        func = func[1].split(")")[0];
        const params = func.split(",");
        const types = [];
        params.map((param) => {
          for (let type of param.split(" ")) {
            if (type != "") {
              types.push(type);
              break;
            }
          }
        });

        func = `${name}(${types.join(",")})`;
        // console.log(func)

        const web3 = new Web3();
        this.selector = web3.eth.abi.encodeFunctionSignature(func);
      }
    },
    togglePercent() {
      this.config.isPercent = !this.config.isPercent;
    },

    toggleWhale() {
      this.config.isWhale = !this.config.isWhale;
    },

    async toggleMassiveBB() {

      this.config.isMassiveBB = !this.config.isMassiveBB;

      if (this.config.isMassiveBB && this.config.isMixedAutoSell) this.config.isMixedAutoSell = false;

      if (this.isAutoPlaying) await this.startBotBBTimer();
    },

    toggleMixedAutoSell() {
      this.config.isMixedAutoSell = !this.config.isMixedAutoSell;
      if (this.config.isMixedAutoSell && this.config.isMassiveBB) this.config.isMassiveBB = false;
    },

    toggleAutoBuy() {
      this.config.isAutoBuy = !this.config.isAutoBuy;
    },

    toggleAutoSell() {
      this.config.isAutoSell = !this.config.isAutoSell;
    },

    toggleWebsite() {
      this.config.isWebsite = !this.config.isWebsite;
    },

    toggleRugLaunch() {
      this.config.isRugLaunch = !this.config.isRugLaunch;
    },

    // toggleMultiSelection() {
    //   this.config.isMultiSelection = !this.config.isMultiSelection;
    // },
    percentToScaledBigInt(percent, scale = 5) {
      const str = String(percent ?? "").trim();
      if (!str) return 0n;

      const match = str.match(/^(-?\d*)(?:\.(\d*))?$/);
      if (!match) return 0n;

      const whole = match[1] || "0";
      const fraction = (match[2] || "")
        .padEnd(scale, "0")
        .slice(0, scale);

      return BigInt(`${whole}${fraction}`);
    },
    minTokenAmountFromSupplyPercent(totalSupply, percent, scale = 5) {
      const percentScaled = this.percentToScaledBigInt(percent, scale);
      // percent is % of total supply (e.g. 0.1 = 0.1%, 0.00001 = 0.00001%)
      return (percentScaled * totalSupply) / BigInt(10 ** (scale + 2));
    },
    randomSumCombination(targetSum, count) {
      if (count <= 0 || targetSum <= 0) return;
      const result = [];
      let remainingSum = targetSum;
      let remainingCount = count;

      for (let i = 0; i < count - 1; i++) {
        // Calculate the maximum value for the current position
        const max = remainingSum - (remainingCount - 1); // Ensure at least 1 for each remaining count
        const num = Math.floor(Math.random() * max) + 1; // Random number between 1 and max
        result.push(num);
        remainingSum -= num; // Decrease the remaining sum
        remainingCount--; // Decrease the count of remaining numbers
      }

      // The last number will be the remaining sum to ensure the total equals targetSum
      result.push(remainingSum);

      return result;
    },
    randomIn(array) {
      return array[Math.floor(Math.random() * array.length)];
    },

    randomInWeight(array, minIndex, maxIndex) {
      // Define weights: higher for indices 1 to 6, lower for others
      const weights = Array(array.length).fill(1); // Default weight
      for (let i = minIndex; i <= maxIndex; i++) {
        weights[i] = 10; // Higher weight for indices 1 to 6
      }

      // Calculate total weight
      const totalWeight = weights.reduce((sum, w) => sum + w, 0);

      // Generate random value
      let random = Math.random() * totalWeight;

      // Select index based on weights
      for (let i = 0; i < weights.length; i++) {
        random -= weights[i];
        if (random <= 0) {
          return i;
        }
      }
      return weights.length - 1; // Fallback
    },

    async handleAutoDeposit() {
      this.isAutoDeposit = true;
      // try {
      //   // console.log("Starting Auto Deposit...");
      //   const ethBalanceOfFirstAcc = Math.floor(
      //     parseFloat(this.formatBalance(this.accounts[1].balance)) - 0.05
      //   );
      //   // console.log("ETH Balance of First Account:", ethBalanceOfFirstAcc);

      //   const subAccounts = this.accounts.slice(2, this.accounts.length);
      //   // Filter accounts that have a balance greater than 0
      //   // const filteredEthSubAccounts = subAccounts.filter(
      //   //   (account) => parseFloat(this.formatBalance(account.balance)) < 0.2
      //   // );
      //   let expectedDisperseWallets = Object.keys(this.config.balances)
      //     .filter((key) => {
      //       const wallet = subAccounts.find(
      //         (account) =>
      //           new ethers.Wallet(account.pk).address.toLowerCase() ===
      //           key.toLowerCase()
      //       );
      //       return wallet && Math.floor(Number(this.config.balances[key].token)) === 0;
      //     })
      //     .map((wallet) => wallet.toLocaleLowerCase());

      //   console.log(
      //     "Handle Auto Deposit - Expected Disperse Wallets:",
      //     expectedDisperseWallets
      //   );
      //   const autoDisperseCount = parseInt(this.config.autoDisperseCount, 10);
      //   let selectedRandomAddresses = [];
      //   if (
      //     expectedDisperseWallets.length >=
      //     autoDisperseCount
      //   ) {
      //     // Use Set for better duplicate handling
      //     const selectedNumbers = new Set();
      //     const selectedAddresses = new Set();
          
      //     while (selectedRandomAddresses.length < autoDisperseCount) {
      //       const randomIndex = Math.floor(Math.random() * expectedDisperseWallets.length);
      //       const selectedAddress = expectedDisperseWallets[randomIndex];
            
      //       // Check if this index and address haven't been selected yet
      //       if (!selectedNumbers.has(randomIndex) && !selectedAddresses.has(selectedAddress)) {
      //         selectedNumbers.add(randomIndex);
      //         selectedAddresses.add(selectedAddress);
      //         selectedRandomAddresses.push(selectedAddress);
      //       }
      //     }
      //   } else {
      //     // const filteredEthSubAddresses = subAccounts.filter(
      //     //   (account) => parseFloat(this.formatBalance(account.balance)) < 0.2
      //     // ).map((account) => new ethers.Wallet(account.pk).address.toLowerCase());

      //     selectedRandomAddresses = [...expectedDisperseWallets];
          
      //     // Use Set for better duplicate handling
      //     const selectedNumbers = new Set();
      //     const additionalWalletsNeeded = autoDisperseCount - expectedDisperseWallets.length;
          
      //     // Create a set of already used wallet addresses for faster lookup
      //     const usedWalletAddresses = new Set(expectedDisperseWallets);
          
      //     while (selectedNumbers.size < additionalWalletsNeeded) {
      //       const num = Math.floor((Math.random() * (this.accounts.length - 2)) + 2);
      //       const walletAddress = new ethers.Wallet(this.accounts[num].pk).address.toLowerCase();
            
      //       // Check if this number hasn't been selected and wallet address isn't already used
      //       if (!selectedNumbers.has(num) && !usedWalletAddresses.has(walletAddress)) {
      //         selectedNumbers.add(num);
      //         usedWalletAddresses.add(walletAddress);
      //         selectedRandomAddresses.push(walletAddress);
      //       }
      //     }
      //   }

      //   // const uniqueAddresses = new Set(selectedRandomAddresses);
      //   // selectedRandomAddresses = Array.from(uniqueAddresses);

      //   console.log(
      //     "Selected Random Addresses for Auto Deposit:",
      //     selectedRandomAddresses
      //   );

      //   const step = 0.1; // Step size for distribution
      //   const { distribution } = this.getBestDistribution(
      //     ethBalanceOfFirstAcc,
      //     selectedRandomAddresses.length,
      //     step,
      //     parseFloat(this.config.autoDisperseETH)
      //   );
      //   // console.log("Distribution:", distribution);
      //   const amounts = distribution.map((x) => {
      //     return ethers.utils.parseEther(x.toString());
      //   });

      //   const disperseContract = Ethers.getDisperseContract(
      //     "0xD152f549545093347A162Dce210e7293f1452150"
      //   );

      //   // const txConfig = await this.getTxConfig({
      //   //   action: "buy",
      //   //   type: "normal",
      //   // });

      //   // console.log(ethers.utils.parseEther(ethBalanceOfFirstAcc.toString()));

      //   const tx = await disperseContract.populateTransaction.disperseEther(
      //     selectedRandomAddresses,
      //     amounts,
      //     {
      //       value: ethers.utils.parseEther(ethBalanceOfFirstAcc.toString()),
      //     }
      //   );

      //   const rpc =
      //     "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba";

      //   const provider = new ethers.providers.JsonRpcProvider({
      //     url: rpc,
      //   });

      //   const signer = new ethers.Wallet(this.accounts[1].pk, provider);

      //   const baseMultiplyPerGas = 1.5 * 10;

      //   const feeData = await provider.getFeeData();
      //   const maxPriorityFeePerGas =
      //     (BigInt(feeData.maxPriorityFeePerGas) * BigInt(parseInt(1.1 * 100))) /
      //     BigInt(100);

      //   const maxFeePerGas =
      //     BigInt(feeData.lastBaseFeePerGas) +
      //     (BigInt(parseInt(maxPriorityFeePerGas)) *
      //       BigInt(baseMultiplyPerGas)) /
      //     BigInt(10); // latest

      //   const deployerNonce = await provider.getTransactionCount(
      //     signer.address
      //   );

      //   tx.gasPrice = null;
      //   tx.type = 2;
      //   tx.maxFeePerGas = maxFeePerGas;
      //   tx.maxPriorityFeePerGas = maxPriorityFeePerGas;
      //   tx.gasLimit = 10000000; // gasLimitForBuy;
      //   tx.chainId = 1;
      //   tx.nonce = deployerNonce;

      //   const signed = await signer.signTransaction(tx);
      //   const txReceipt = await provider.sendTransaction(signed);
      //   const result = await txReceipt.wait();
      //   if (result.status === 1) {
      //     this.$toast("Auto Deposit Success!", {
      //       position: "top-right",
      //       timeout: 2000,
      //       closeOnClick: true,
      //     });
      //   } else {
      //     this.$toast.error("Auto Deposit Failed!", {
      //       position: "top-right",
      //       timeout: 2000,
      //       closeOnClick: true,
      //     });
      //   }
      // } catch (error) {
      //   console.log("AutoDeposit Error:", error);
      //   this.$toast.error("Auto Deposit Failed!", {
      //     position: "top-right",
      //     timeout: 2000,
      //     closeOnClick: true,
      //   });
      // }
      const availableBalance = BigInt(this.accounts[1].balance);
      const recipients = [];
      const amounts = [];
      let totalAmount = 0n;
      // const randIndex = Math.floor(Math.random() * (this.accounts.length - 2));
      const token = this.$route.params.address;
      const availableAccounts = this.accounts.slice(2);
      const disperseContract = Ethers.getDisperseContract("0x51c321A43Da7518F743D58FED56072d2096321E8");
      const tokenBalances = await disperseContract.getBalances(token, availableAccounts.map(account => account.get('address')));
      const sortedAccounts = availableAccounts.map((account, index) => ({
        account,
        balance: tokenBalances[index]
      })).sort((a, b) => a.balance - b.balance);
      for(let i = 0; i < sortedAccounts.length; i ++) {
        if(BigInt(sortedAccounts[i].account.balance) > BigInt(utils.parseEther(this.config.buyAmount.toString()))) continue;
        // const accountIndex = (i + randIndex) % (this.accounts.length - 2) + 2;
        // TODO: 1% ~ 5%
        const baseAmount = parseFloat(this.config.minDisperseAmount) * 100;
        const addAmount = parseFloat(this.config.maxDisperseAmount) * 100 - baseAmount;
        const depositAmount = BigInt(Math.floor(baseAmount + this.generateRandomAmount(0, 1, 7) * addAmount)) * 10n ** 18n / 100n;
        if(totalAmount + depositAmount > availableBalance) {
          break;
        }
        // recipients.push(this.accounts[accountIndex].get('address'));
        recipients.push(sortedAccounts[i].account.get('address'));
        amounts.push(depositAmount);
        totalAmount += depositAmount;
      }
      if (amounts.length == 0 || totalAmount == 0n) {
        this.isAutoDeposit = false;
        return;
      }

      try {
        const txConfig = await this.getTxConfig({
          action: 'buy'
        });
        const signer = Ethers.getWallet(this.accounts[1].pk);
        
        // disperse.app
        const disperseAppContract = Ethers.getDisperseAppContract("0x0BC23B69edBF2cb3CDd57a75454657e2d00047f5");
        const disperseRequest = await disperseAppContract.connect(signer).disperseEther(recipients, amounts, {
          gasLimit: txConfig.gas * 10,
          maxFeePerGas: txConfig.maxFeePerGas,
          maxPriorityFeePerGas: txConfig.maxPriorityFeePerGas,
          value: totalAmount,
          type: 2,
        });
        
        // Uniswap V4 Universal Router
        // const uniswapV4UniversalRouter = Ethers.getUniswapV4UniversalRouterContract("0x66a9893cC07D91D95644AEDD05D03f95e1dBA8Af");
        // const commands = "0x" + "05".repeat(recipients.length);
        // const abiCoder = ethers.utils.defaultAbiCoder;
        // const inputs = recipients.map((recipient, idx) => 
        //   abiCoder.encode(["address", "address", "uint256"], ["0x0000000000000000000000000000000000000000", recipient, BigInt(amounts[idx])])
        // );
        // const disperseRequest = await uniswapV4UniversalRouter.connect(signer)["execute(bytes,bytes[])"](commands, inputs, {
        //   gasLimit: txConfig.gas * 10,
        //   maxFeePerGas: txConfig.maxFeePerGas,
        //   maxPriorityFeePerGas: txConfig.maxPriorityFeePerGas,
        //   value: totalAmount,
        //   type: 2,
        // });

        /* const calldata = utils.defaultAbiCoder.encode(["address[]", "uint256[]"], [recipients, amounts]);
        const fundWalletsAndSelfDestruct_bytecode = "0x6080604052604051610285380380610285833981016040819052610022916101a7565b5f5b825181101561009e5782818151811061003f5761003f610270565b60200260200101516001600160a01b03166108fc83838151811061006557610065610270565b602002602001015190811502906040515f60405180830381858888f19350505050158015610095573d5f803e3d5ffd5b50600101610024565b504780156100d257604051339082156108fc029083905f818181858888f193505050501580156100d0573d5f803e3d5ffd5b505b33ff5b634e487b7160e01b5f52604160045260245ffd5b604051601f8201601f191681016001600160401b0381118282101715610111576101116100d5565b604052919050565b5f6001600160401b03821115610131576101316100d5565b5060051b60200190565b5f82601f83011261014a575f80fd5b8151602061015f61015a83610119565b6100e9565b8083825260208201915060208460051b870101935086841115610180575f80fd5b602086015b8481101561019c5780518352918301918301610185565b509695505050505050565b5f80604083850312156101b8575f80fd5b82516001600160401b03808211156101ce575f80fd5b818501915085601f8301126101e1575f80fd5b815160206101f161015a83610119565b82815260059290921b8401810191818101908984111561020f575f80fd5b948201945b838610156102415785516001600160a01b0381168114610232575f80fd5b82529482019490820190610214565b91880151919650909350505080821115610259575f80fd5b506102668582860161013b565b9150509250929050565b634e487b7160e01b5f52603260045260245ffdfe"
        const data = fundWalletsAndSelfDestruct_bytecode + calldata.slice(2);

        const tx = {
          from: signer.address,
          data,
          maxFeePerGas: txConfig.maxFeePerGas,
          maxPriorityFeePerGas: txConfig.maxPriorityFeePerGas,
          value: totalAmount,
          type: 2,
        };
        const gasLimit = await Ethers.estimateGas(tx);
        tx.gasLimit = gasLimit;
        const disperseRequest = await Ethers.sendTransaction(tx, this.accounts[1].pk);*/

        await Ethers.waitForTransaction(disperseRequest.hash);
        this.$toast("Deposited successfully", {
          position: "top-right",
          timeout: 2000,
          closeOnClick: true,
        });
      } catch (e) {
        console.log(e);
        this.alertModalTitle = "Error";
        this.alertModalIcon = "error";
        this.alertModalActive = true;
        this.alertModalContent =
          "There was an error on deposit. Please try again.";
        this.alertModalBtnOk = "Ok";
        this.alertModalCallback = null;
      }
      this.isAutoDeposit = false;
    },

    async handleAutoPlaying() {
      // const gasPrice = await Web3Helper.getGasPrice();
      // const formatedGasPrice = parseFloat(
      //   Number(ethers.utils.formatUnits(gasPrice, 9)).toFixed(2)
      // );

      const ethBalanceOfFirstAcc = parseFloat(
        this.formatBalance(this.accounts[1].balance)
      );

      // console.log("ETH Balance of First Account:", ethBalanceOfFirstAcc);

      const currentPoolSize = await this.getCurrentPoolWETHAmount();
      console.log("Current Pool Size:", currentPoolSize);
      if (currentPoolSize <= 1) {
        return;
      }

      if (!this.isAutoDeposit && ethBalanceOfFirstAcc >= 3.1)
        await this.handleAutoDeposit();

      // console.log("Auto Playing Phase:", this.autoPlayingPhase);
      const totalBalance = this.getTotalBalance();
      const subBalance = Math.floor(
        totalBalance -
        this.formatBalance(
          parseFloat(
            this.accounts[0].balance
              ? parseFloat(this.accounts[0].balance)
              : 0
          )
        )
      );
      // console.log("Sub Balance:", subBalance);

      const poolSizeRatio = currentPoolSize / this.config.targetPoolSize; // Normalize pool size

      const TYPICAL_MIN = 0.5; // When currentPoolSize is low relative to target
      const TYPICAL_MAX = 1.5; // When currentPoolSize is high relative to target
      const SPECIAL_MIN = 0.1; // Special case: very low pool
      const SPECIAL_MAX = 2.5; // Special case: very high pool
      const TRADE_HISTORY_LIMIT = 3; // Track last 3 trades (~72s)
      const SELL_BIAS_THRESHOLD = 1; // Boost buy probability after 1 sell

      // Track recent trades (persists across 24s intervals)
      this.tradeHistory = this.tradeHistory || [];
      if (this.tradeHistory.length > TRADE_HISTORY_LIMIT) {
        this.tradeHistory.shift(); // Remove oldest trade
      }

      // Count recent sells
      const recentSellCount = this.tradeHistory.filter(
        (signal) => signal === "sell"
      ).length;

      let buyProbability = 0.5; // 50% chance to buy
      if (
        currentPoolSize >
        Math.min(
          this.config.targetPoolSize,
          currentPoolSize + subBalance - 5
        ) &&
        this.autoPlayingPhase === "pump"
      ) {
        this.config.targetPoolSize = this.roundToTargetPoolSizeList(
          this.config.targetPoolSize
        );

        // if (currentPoolSize >= this.config.targetPoolSize) {
        //   this.autoPlayingPhase = "dump"; // Switch to dump phase if target reached
        // } else {
        //   this.autoPlayingPhase = "pump"; // Switch to pump phase if target reached
        // }
      } else if (
        currentPoolSize < this.config.targetPoolSize &&
        this.autoPlayingPhase === "dump"
      ) {
        this.config.targetPoolSize = this.roundToTargetPoolSizeList(
          this.config.targetPoolSize
        );
        // if (currentPoolSize >= this.config.targetPoolSize) {
        //   this.autoPlayingPhase = "dump"; // Switch to dump phase if target reached
        // } else {
        //   this.autoPlayingPhase = "pump"; // Switch to pump phase if target reached
        // }
      }
      // console.log("Current Target Pool Size:", this.config.targetPoolSize);
      // Adjust probability based on phase
      if (this.autoPlayingPhase === "pump") {
        // 60% buy at poolSizeRatio = 1 (balanced), 80% at 0.5 (low), 40% at 1.5 (high)
        const normalizedRatio = Math.min(
          Math.max(poolSizeRatio, TYPICAL_MIN),
          TYPICAL_MAX
        );
        buyProbability = 0.6 + 0.2 * (1 - normalizedRatio); // Linear from 80% to 40%
        if (poolSizeRatio < TYPICAL_MIN) {
          // Special case: up to 90% buy at poolSizeRatio = 0.1
          buyProbability = Math.min(
            0.9,
            0.8 + 0.25 * (TYPICAL_MIN - Math.max(poolSizeRatio, SPECIAL_MIN))
          );
        }
      } else {
        // phase === "dump"
        // 40% buy at poolSizeRatio = 1 (balanced), 60% at 0.5 (low), 20% at 1.5 (high)
        const normalizedRatio = Math.min(
          Math.max(poolSizeRatio, TYPICAL_MIN),
          TYPICAL_MAX
        );
        buyProbability = 0.4 - 0.2 * (normalizedRatio - 1); // Linear from 60% to 20%
        if (poolSizeRatio > TYPICAL_MAX) {
          // Special case: down to 10% buy at poolSizeRatio = 2.5
          buyProbability = Math.max(
            0.1,
            0.4 - 0.15 * (Math.min(poolSizeRatio, SPECIAL_MAX) - TYPICAL_MAX)
          );
        }
      }

      // Throttle selling if recent sells are high and pool isn't very high
      if (
        recentSellCount >= SELL_BIAS_THRESHOLD &&
        poolSizeRatio < SPECIAL_MAX
      ) {
        buyProbability = Math.min(1, buyProbability + 0.15 * recentSellCount);
      }

      // Ensure probability in [0, 1]
      buyProbability = Math.max(0, Math.min(1, buyProbability));

      const buyOrSellSignal = Math.random() < buyProbability ? "buy" : "sell";

      // Update trade history
      this.tradeHistory.push(buyOrSellSignal);

      const buyCounts = [1, 2, 3];
      const sellCounts = [1, 2];
      const sellETHAmountCandidates = [1, 1.5, 2, 2.5, 3];

      const buyCount = buyCounts[this.randomInWeight(buyCounts, 1, 3)];
      const sellCount = sellCounts[this.randomIn(sellCounts)];

      if (buyOrSellSignal === "buy") {
        // console.log("Auto Buy Signal Detected");
        await this.onAutoBuy("autobuy", buyCount);
      } else {
        // console.log("Auto Sell Signal Detected");
        let minIndex, maxIndex;
        if (
          this.autoPlayingPhase === "pump" &&
          poolSizeRatio < 1 &&
          poolSizeRatio >= 0.8
        ) {
          // Pump, pool low, relatively high ratio: bias towards 1, 1.5
          minIndex = 0;
          maxIndex = 1;
        } else if (
          this.autoPlayingPhase === "dump" &&
          poolSizeRatio > 1 &&
          poolSizeRatio >= TYPICAL_MAX
        ) {
          // Dump, pool high, relatively high ratio: bias towards 2, 2.5, 3
          minIndex = 2;
          maxIndex = 4;
        } else {
          // Default: bias towards smaller amounts (1, 1.5, 2)
          minIndex = 0;
          maxIndex = 2;
        }
        const selectedIndex = this.randomInWeight(
          sellETHAmountCandidates,
          minIndex,
          maxIndex
        );
        const sellETHAmount = sellETHAmountCandidates[selectedIndex];
        await this.onAutoSell("autosell", sellCount, sellETHAmount);
      }

      if (currentPoolSize < this.config.targetPoolSize) {
        this.autoPlayingPhase = "pump";
      } else this.autoPlayingPhase = "dump";
    },

    handleRefresh() {
      this.pending.multibuy = false;
      this.pending.autobuy = false;
      this.pending.autosell = false;
      this.pending.mixtrade = false;
      this.pending.autosell = false;
      this.pending.autofixedSell = false;
    },

    handleKeyDown(event) {

      
      if(event.target.tagName === 'INPUT' && (event.target.type === 'text' || event.target.type === 'number')) {
        event.stopImmediatePropagation();
        return;
      }

      if(event.key >= '0' && event.key <= '9' && event.code.startsWith('Digit'))
        this.config.multiSelectionCnt = Number(event.key) === 0 ? 10 : Number(event.key);

      if(event.code === this.lastKeyCode) {
        switch (event.code) {
          case "KeyF":
            this.onLaunch("multibuy" , false);
            break;
          case "KeyT":
            this.onAutoBuy("autobuy", this.autobuyCount);
            break;
        }
        this.lastKeyCode = ''
      } else {
        switch (event.code) {
          case "KeyR":
            this.handleRefresh();
            break;
        }
        this.lastKeyCode = event.code;  
      }
      
    },

    async onAutoPlay() {
      this.isAutoPlaying = !this.isAutoPlaying;
      if (this.isAutoPlaying) await this.startBotBBTimer();
    },

    async onLoop() {
      this.loopPending = true;
      const gasMultiply = 130;
      try {
        const contract = Web3Helper.getMultiSwapContract();
        console.log(contract);
        let func = "excute";

        const buyPath = [
          Web3Helper.getWETHAddress(),
          this.$route.params.address,
        ];
        const sellPath = [
          this.$route.params.address,
          Web3Helper.getWETHAddress(),
        ];

        const amounts = [];
        let totalAmount = 0;
        for (let i = 0; i < this.config.loopCount1; i++) {
          const _min = parseFloat(this.config.minAmount);
          const _max = parseFloat(this.config.maxAmount);
          const rAmount = parseFloat(
            (_min + Math.random() * (_max - _min)).toFixed(6)
          );
          console.log(rAmount);
          amounts.push(ethers.utils.parseEther(rAmount.toString()));
          amounts.push(0);
          if (totalAmount < rAmount) totalAmount = rAmount;
        }
        for (let i = 0; i < this.config.loopCount2; i++) {
          const _min = parseFloat(this.config.minAmount);
          const _max = parseFloat(this.config.maxAmount);
          const rAmount = parseFloat(
            (_min + Math.random() * (_max - _min)).toFixed(6)
          );
          console.log(rAmount);
          amounts.push(ethers.utils.parseEther(rAmount.toString()));
          totalAmount += rAmount;
        }
        amounts.push(0);
        totalAmount += 0.01;

        const gasPrice = await Web3Helper.getGasPrice();
        console.log(gasPrice);

        // c39d819bfad2d07b438420e07db592878265d9a1f991c556593fa628b1054a65
        const account = Web3Helper.web3.eth.accounts.privateKeyToAccount(
          this.config.lpk
        );

        const options = {
          from: account.address,
          to: Web3Helper.getMultiSwapAddress(),
          gasPrice: Utils.formatBigInt(
            parseInt((gasPrice * gasMultiply) / 100)
          ),
        };

        let params = [amounts, buyPath, sellPath];
        console.log(params, totalAmount);

        totalAmount = ethers.utils.parseEther(totalAmount.toString());

        options["value"] = totalAmount;

        console.log(options);

        const tx = contract.methods[func](...params);

        let gasLimit = await tx.estimateGas(options);
        options.gas = gasLimit;
        console.log(gasLimit);
        const response = await Web3Helper.send(tx, this.config.lpk, options);
        this.$toast("Success", {
          position: "top-right",
          timeout: 2000,
          closeOnClick: true,
        });
        console.log(response);
      } catch (e) {
        console.log(e);
        this.$toast.error("Error", {
          position: "top-right",
          timeout: 2000,
          closeOnClick: true,
        });
      }
      this.loopPending = false;
    },

    async onAutoBuy(type, buyCount = 2) {
      this.pending[type] = true;

      if (this.config.currentTokenPoolETH < 1.0) {
        this.$toast.error("Low Liquidity Pool . Can't Buy", {
          position: "top-right",
          timeout: 2000,
          closeOnClick: true,
        });
        this.pending[type] = false;
        return;
      }

      try {
        const subWallets = this.accounts.slice(2, this.accounts.length).map((account) => {
          if (account.pk)
            return new ethers.Wallet(account.pk).address.toLowerCase();
        });

        let accounts = this.accounts.slice(2, this.accounts.length).filter(
          (account) =>
            account.pk &&
            parseFloat(this.formatBalance(account.balance)) >=
            // (this.config.isAutoBuy ? parseFloat(this.config.buyAmount) : 0.1)
            parseFloat(this.config.buyAmount)
        );

        let privateKeys = [];
        if (!accounts || accounts.length == 0) {
          this.$toast.error(
            "No accounts found with sufficient balance ( >= 0.1)",
            {
              position: "top-right",
              timeout: 2000,
              closeOnClick: true,
            }
          );
          this.pending[type] = false;
          return;
        }
        // console.log('account Balances: --' , accounts)
        let balances = {};
        let msgSubIndexers = [];
        let autoBuyCount = this.config.isAutoBuy
          ? Math.floor(Math.random() * (buyCount - 1) + 1)
          : buyCount;
        /* eslint-disable no-constant-condition */
        // while (true) {
        let randomIndexes = [];
        // const uniqueRandomIndexes = new Set();
        let randomIndex = 0;
        while (
          randomIndex < Math.min(autoBuyCount, accounts.length)
        ) {
          while (true) {
            const randomIdx = Math.floor(Math.random() * accounts.length);
            if (!randomIndexes.includes(randomIdx)) {
              randomIndexes.push(randomIdx);
              randomIndex++;
              break;
            }
          }
        }

        // randomIndexes = Array.from(uniqueRandomIndexes);

        accounts = accounts.filter((_, index) =>
          randomIndexes.includes(index)
        );

        privateKeys = accounts.map((account) => account.pk);

        Object.keys(this.config.balances).map((key) => {
          const wallet = accounts.find(
            (account) =>
              new ethers.Wallet(account.pk).address.toLowerCase() ===
              key.toLowerCase()
          );
          if (!wallet) return;
          balances[key] = {
            ...this.config.balances[key],
            eth: wallet.balance,
          };
        });

        Object.keys(balances).forEach((key) => {
          const indexOfKey = subWallets.indexOf(key.toLowerCase());
          msgSubIndexers.push(indexOfKey);
        });

        // const duplicateAutoPlaying = this.autoSellIndexes.some((index) =>
        //   msgSubIndexers.includes(index)
        // );
        // if (!duplicateAutoPlaying || !this.pending.autosell) {
        //   this.autoBuyIndexes = msgSubIndexers; //autoBuyingIndexes Filling
        //   break;
        // }
        // }
        // console.log("Selected Indexes for AutoBuy : ", this.autoBuyIndexes);

        if (!msgSubIndexers || !balances) {
          this.$toast.error("No accounts found with sufficient balance", {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
          this.pending[type] = false;
          return;
        }
        // const gasPrice = await Web3Helper.getGasPrice();
        // console.log(gasPrice);

        const { data: response } = await axios.post(
          `${Config.PEIN_URL}/processFlashBots`,
          {
            dpk: this.config.dpk,
            minerReward: parseFloat(this.config.tipAmount),
            enableProc: this.config.enableProc,
            isFlashBot: false,
            minAmount: parseFloat(this.config.minAmount),
            maxAmount: parseFloat(this.config.maxAmount),
            buyerPvtKeys: privateKeys,
            tokenAddr: this.$route.params.address,
            isWhale: this.config.isWhale,
            isMixed: false,
            balances,
            isPercent: this.config.isPercent,
            basePerGas: this.config.basePerGas,
            baseCnt: this.config.baseCnt,
            isRandom: this.config.random,
            isAutoBuy: this.config.isAutoBuy
          }
        );

        if (response.msg === "Success") {
          let msg = "Auto Buy Completed : ";
          msgSubIndexers.map((value, index) => {
            msg += `${value}`;
            if (index != msgSubIndexers.length - 1) msg += ",";
          });
          this.$toast(msg, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
        } else {
          this.$toast.error(response.msg, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
        }
      } catch (e) {
        console.log(e);
      }
      this.pending[type] = false;
    },
    //My Logic
    async onAutoSell(type, autoSellCount = 2, sellETHAmount = 1) {
      this.pending[type] = true;
      try {
        const routerContract = Ethers.getUniswapV2RouterContract(
          Web3Helper.getDexList()[this.config.factory].router
        );
        const token = this.$route.params.address;
        const path = [Web3Helper.getWETHAddress(), token];
        const amounts = await routerContract.getAmountsOut(
          ethers.utils.parseEther(sellETHAmount.toString()),
          path
        );
        const totalTokenAmount = Math.floor(this.formatBalance(amounts[1], 9));

        // const startStep = Math.floor(Math.random() * 50);
        console.log("Total amount of tokens for sell: ", totalTokenAmount);
        let randomDividedAmount = [];
        randomDividedAmount = this.randomSumCombination(100, autoSellCount);
        randomDividedAmount.sort(function (a, b) {
          return b - a;
        });

        let accounts = this.accounts.filter((account) => account.pk);
        const firstWallet = new ethers.Wallet(this.accounts[1].pk).address;
        // console.log('account Balances: --' , accounts)

        // let privateKeys = accounts.map((account) => account.pk);

        // const totalSupply = BigInt(this.contract.get("totalSupply"));
        const totalSupply = BigInt('100000000');
        const minBaseTokenAmount = this.minTokenAmountFromSupplyPercent(
          totalSupply,
          this.config.autoSellBasePercent
        );

        const filteredWallets = Object.keys(this.config.balances)
          .filter((key) => {
            const wallet = accounts.find(
              (account) =>
                new ethers.Wallet(account.pk).address.toLowerCase() ===
                key.toLowerCase()
            );

            // Check if wallet exists and if the token balance meets the minimum requirement
            return (
              wallet &&
              BigInt(parseInt(this.config.balances[key].token)) >=
              minBaseTokenAmount
            );
          })
          .map((wallet) => wallet.toLowerCase());

        let filteredAccounts = accounts.filter((account) =>
          filteredWallets.includes(
            new ethers.Wallet(account.pk).address.toLowerCase()
          )
        );

        // if (!filteredAccounts || filteredAccounts.length == 0) {
        //   this.$toast("No accounts found with sufficient token balance", {
        //     position: "top-right",
        //     timeout: 2000,
        //     closeOnClick: true,
        //   });
        //   return;
        // }

        const randomSellFinalCount = Math.min(
          this.autoSellCount,
          filteredAccounts.length
        );

        let randomIndexes = [];
        const uniqueRandomIndexes = new Set();
        while (uniqueRandomIndexes.size < randomSellFinalCount) {
          uniqueRandomIndexes.add(
            Math.floor(Math.random() * filteredAccounts.length) + 1
          );
        }

        randomIndexes = Array.from(uniqueRandomIndexes);

        filteredAccounts = filteredAccounts.filter((account, index) =>
          randomIndexes.includes(index)
        );

        if (!filteredAccounts || filteredAccounts.length === 0) {
          this.$toast("No accounts found with sufficient token balance", {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });

          return;
        }
        // console.log("Picked Address: ", filteredAccounts);

        let balances = {};
        Object.keys(this.config.balances).forEach((key) => {
          const wallet = filteredAccounts.find(
            (account) =>
              new ethers.Wallet(account.pk).address.toLowerCase() ===
              key.toLowerCase()
          );
          if (!wallet) return;
          balances[key] = parseInt(this.config.balances[key].token);
        });

        // Sort the balances object by values
        let sortedBalances = Object.entries(balances)
          .sort(([, valueA], [, valueB]) => valueB - valueA) // Sort in descending order
          .reduce((acc, [key, value], index) => {
            acc[key] = {
              token: value,
              percent: randomDividedAmount[index],
            }; // Rebuild the object
            return acc;
          }, {});

        let finalSellEntries = {};
        const subWallets = accounts.map((account) =>
          new ethers.Wallet(account.pk).address.toLowerCase()
        );

        const sellIndexes = [];

        Object.keys(sortedBalances).map((key) => {
          if (!sortedBalances[key].percent) return;
          // console.log(
          //   `acc-${subWallets.indexOf(key.toLowerCase()) + 1} : ${
          //     sortedBalances[key].percent
          //   } , ${sortedBalances[key].token} , ${Math.min(
          //     Math.floor(
          //       (totalTokenAmount * sortedBalances[key].percent) / 100
          //     ),
          //     Math.floor((sortedBalances[key].token * 99) / 100)
          //   )}`
          // );
          finalSellEntries[key] = Math.min(
            Math.floor((totalTokenAmount * sortedBalances[key].percent) / 100),
            Math.floor((sortedBalances[key].token * 99) / 100)
          );

          const indexOfKey = subWallets.indexOf(key.toLowerCase());
          sellIndexes.push(indexOfKey);
        });

        this.autoSellIndexes = sellIndexes;

        // console.log("Selected Indexes for AutoSell : ", this.autoSellIndexes);
        const router = Web3Helper.getDexList()[this.config.factory].router;

        const approvePromises = filteredAccounts.map(async (account) => {
          const allowance = await this.allowance({
            account,
            contract: this.contract,
            isOriginalRouter: true,
            router,
          });
          if (BigInt(allowance) != BigInt(0)) return;
          await this.approve({
            account,
            contract: this.contract,
            isOriginalRouter: true,
            router,
          });
        });

        await Promise.all(approvePromises);

        const rpc =
          "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba";
        const provider = new ethers.providers.JsonRpcProvider({
          url: rpc,
        });

        let results = {};
        let recipient = this.config.autosellRecipientAddress;
        if (!recipient) recipient = firstWallet;
        if ((await Ethers.getCodeLength(recipient)) != 2) {
          recipient = firstWallet;
          this.$toast.error(
            "Invalid recipient address. Fallback to first wallet.",
            {
              position: "top-right",
              timeout: 2000,
              closeOnClick: true,
            }
          );
        }
        const isWhitelisted =
          whitelists.whitelist
            .map((x) => x.toLowerCase())
            .some((x) => x === recipient.toLowerCase()) ||
          this.accounts
            .map((x) => x.get("address").toLowerCase())
            .some((x) => x === recipient.toLowerCase());
        if (!isWhitelisted) {
          recipient = firstWallet; // Fallback to first wallet if recipient is not whitelisted
          this.$toast.error(
            "Invalid recipient address. Fallback to first wallet.",
            {
              position: "top-right",
              timeout: 2000,
              closeOnClick: true,
            }
          );
        }

        const promises = Object.keys(finalSellEntries).map(async (key) => {
          const wallet = filteredAccounts.find(
            (account) =>
              new ethers.Wallet(account.pk).address.toLowerCase() ===
              key.toLowerCase()
          );
          const amountIn = ethers.utils.parseUnits(
            finalSellEntries[key].toString(),
            9
          );
          const path = [
            this.contract.get("address"),
            Web3Helper.getWETHAddress(),
          ];
          // const amountOut = await routerContract.getAmountsOut(amountIn, path);
          const tx =
            await routerContract.populateTransaction.swapExactTokensForETHSupportingFeeOnTransferTokens(
              amountIn,
              0,
              path,
              recipient,
              new Date().getTime()
            );

          const signer = new ethers.Wallet(wallet.pk);

          const deployerNonce = await provider.getTransactionCount(
            signer.address
          );

          const gasPrice = await provider.getGasPrice();
          const newGasPrice = gasPrice.add(
            ethers.utils.parseUnits("0.2", "gwei")
          );
          tx.gasPrice = newGasPrice;
          tx.type = 1;
          // multicallTx.maxFeePerGas = maxFeePerGas;
          // multicallTx.maxPriorityFeePerGas = maxPriorityFeePerGas;
          tx.gasLimit = 300000; // gasLimitForBuy;
          tx.chainId = 1;
          tx.nonce = deployerNonce;

          const signed = await signer.signTransaction(tx);
          const txReceipt = await provider.sendTransaction(signed);
          const result = await txReceipt.wait();
          results[key] = result;
          console.log("AutoSell tx :", tx);
        });

        await Promise.all(promises); // Wait for all transactions to complete

        let successResults = [],
          failedResults = [];

        Object.keys(results).forEach((key) => {
          const indexOfKey = subWallets.indexOf(key.toLowerCase()) + 1;
          if (results[key].status === 1)
            successResults.push({ key, indexOfKey });
          else failedResults.push({ key, indexOfKey });
        });

        let msg = "Auto Sell Completed : ";
        successResults.map((result, index) => {
          msg += `${result.indexOfKey}`;
          if (index != successResults.length - 1) msg += ",";
        });
        console.log(msg);
        this.$toast(msg, {
          position: "top-right",
          timeout: 2000,
          closeOnClick: true,
        });

        if (failedResults.length > 0) {
          msg = "Auto Sell Failed : ";
          failedResults.map((result, index) => {
            msg += `${result.indexOfKey}`;
            if (index != failedResults.length - 1) msg += ",";
          });
          console.log(msg);
          this.$toast.error(msg, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
        }
      } catch (e) {
        console.log(e);
      }
      this.pending[type] = false;
      this.autoSellIndexes = [];
    },
    //Golden Logic
    async handleAutoSell() {

      this.pending.autofixedSell = true;

      const availableAccountsIndex = [];
      const token = this.$route.params.address;
      const disperseContract = Ethers.getDisperseContract(
        "0x51c321A43Da7518F743D58FED56072d2096321E8"
      );
      const tokenBalances = await disperseContract.getBalances(
        token,
        this.accounts.map((account) => account.get("address"))
      );
      let amountIn;
      if (parseFloat(this.config.sellETHAmount) == 0.0)
        amountIn = 20000n * 10n ** 9n;
      else {
        const amountOut = BigInt(
          ethers.utils.parseEther(this.config.sellETHAmount.toString())
        );
        const factoryContract = Web3Helper.getUniswapV2FactoryContract(
          Web3Helper.getDexList()[this.config.factory].address
        );
        const pairAddress = await factoryContract.methods
          .getPair(token, Web3Helper.getWETHAddress())
          .call();
        const pairContract = Web3Helper.getUniswapV2PairContract(pairAddress);
        const [reserves, token0] = await Promise.all([
          pairContract.methods.getReserves().call(),
          pairContract.methods.token0().call(),
        ]);
        let reserveIn = BigInt(reserves._reserve0);
        let reserveOut = BigInt(reserves._reserve1);
        if (token0.toLowerCase() != token.toLowerCase()) {
          reserveIn = BigInt(reserves._reserve1);
          reserveOut = BigInt(reserves._reserve0);
        }
        const numerator = reserveIn * amountOut * 1000n;
        const denominator = (reserveOut - amountOut) * 997n;
        amountIn = numerator / denominator + 1n;
      }

      for (let i = 1; i < this.accounts.length; i++) {
        if (
          BigInt(this.accounts[i].balance) >= 2n ** 15n &&
          tokenBalances[i] > amountIn
        ) {
          availableAccountsIndex.push(i);
        }
      }

      if (availableAccountsIndex.length === 0) {
        this.$toast.error("No accounts to sell which meets requirements", {
          position: "top-right",
          timeout: 2000,
          closeOnClick: true,
        });
        this.pending.autofixedSell = false;
        return;
      }

      const maxBuyCount = Math.floor(Math.random() * this.autoSellCount) + 1;
      const selectedIndexes = [];
      for (let i = 0; i < maxBuyCount; i++) {
        const index = Math.floor(Math.random() * availableAccountsIndex.length);
        selectedIndexes.push(availableAccountsIndex[index]);
      }
      let filteredAccounts = this.accounts.filter((_, index) =>
        selectedIndexes.includes(index)
      );
      const router = Web3Helper.getDexList()[this.config.factory].router;

      const filteredTokenBalances = await disperseContract.getBalances(
        token,
        filteredAccounts.map((account) => account.get("address"))
      );
      const approvePromises = filteredAccounts.map(async (account) => {
        const allowance = await this.allowance({
          account,
          contract: this.contract,
          isOriginalRouter: true,
          router,
        });
        if (BigInt(allowance) != BigInt(0)) return;
        await this.approve({
          account,
          contract: this.contract,
          isOriginalRouter: true,
          router,
        });
      });

      await Promise.all(approvePromises);

      const firstWallet = new ethers.Wallet(this.accounts[1].pk).address;
      const rpc =
        "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba";
      const provider = new ethers.providers.JsonRpcProvider({
        url: rpc,
      });

      let recipient = this.config.autosellRecipientAddress;
      if (!recipient) recipient = firstWallet;
      if ((await Ethers.getCodeLength(recipient)) != 2) {
        recipient = firstWallet;
        this.$toast.error(
          "Invalid recipient address. Fallback to first wallet.",
          {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          }
        );
      }
      const isWhitelisted =
        whitelists.whitelist
          .map((x) => x.toLowerCase())
          .some((x) => x === recipient.toLowerCase()) ||
        this.accounts
          .map((x) => x.get("address").toLowerCase())
          .some((x) => x === recipient.toLowerCase());
      if (!isWhitelisted) {
        recipient = firstWallet; // Fallback to first wallet if recipient is not whitelisted
        this.$toast.error(
          "Invalid recipient address. Fallback to first wallet.",
          {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          }
        );
      }
      const routerContract = Ethers.getUniswapV2RouterContract(
        Web3Helper.getDexList()[this.config.factory].router
      );
      if (this.config.isMassiveBB) {
        const sellPromises = filteredAccounts.map(async (account, index) => {
          const signer = new ethers.Wallet(account.pk);
          const path = [token, Web3Helper.getWETHAddress()];
          const randomizedAmountIn =
            parseFloat(this.config.sellETHAmount) == 0.0
              ? BigInt(filteredTokenBalances[index]) * BigInt(this.config.sellPercent) / 100n
              : (BigInt(amountIn) *
                BigInt(Math.floor(Math.random() * 200 + 800))) /
              1000n;
          const tx =
            await routerContract.populateTransaction.swapExactTokensForETHSupportingFeeOnTransferTokens(
              randomizedAmountIn,
              0,
              path,
              recipient,
              Number.parseInt(new Date().getTime() / 1000) + 150
            );

          const deployerNonce = await provider.getTransactionCount(
            signer.address
          );

          const gasPrice = await provider.getGasPrice();
          const newGasPrice = gasPrice.add(
            ethers.utils.parseUnits("0.1", "gwei")
          );
          tx.gasPrice = newGasPrice;
          tx.type = 1;
          // multicallTx.maxFeePerGas = maxFeePerGas;
          // multicallTx.maxPriorityFeePerGas = maxPriorityFeePerGas;
          tx.gasLimit = 300000; // gasLimitForBuy;
          tx.chainId = 1;
          tx.nonce = deployerNonce;

          const signed = await signer.signTransaction(tx);

          const txReceipt = await provider.sendTransaction(signed);
          await txReceipt.wait();
        });

        await Promise.all(sellPromises); // Wait for all transactions to complete
      } else if (this.config.isMixedAutoSell) {
        let privateKeys = filteredAccounts.map((account) => account.pk);
        let balances = {};
        Object.keys(this.config.balances).map((key) => {
          const wallet = filteredAccounts.find(
            (account) =>
              new ethers.Wallet(account.pk).address.toLowerCase() ===
              key.toLowerCase()
          );
          if (!wallet) return;
          balances[key] = {
            ...this.config.balances[key],
            eth: wallet.balance,
          };
        });

        const randomizedAmountIns = filteredAccounts.map((_, index) => {
          const randomizedAmount = BigInt(amountIn) * BigInt(Math.floor(Math.random() * 200 + 800)) / 1000n;
          return parseFloat(this.config.sellETHAmount) == 0.0
            ? (BigInt(filteredTokenBalances[index]) * BigInt(this.config.sellPercent) / 100n).toString() : randomizedAmount.toString();
          // : Math.floor(Number((randomizedAmount * 100n) / BigInt(filteredTokenBalances[index])))
        })

        const { data: response } = await axios.post(
          `${Config.PEIN_URL}/processFlashBots`,
          {
            minerReward: parseFloat(this.config.tipAmount),
            minAmount: parseFloat(this.config.minAmount),
            maxAmount: parseFloat(this.config.maxAmount),
            buyerPvtKeys: privateKeys,
            tokenAddr: this.$route.params.address,
            basePerGas: this.config.basePerGas,
            balances,
            isMixed: true,
            amountIns: randomizedAmountIns,
            isMixedAutoSell: this.config.isMixedAutoSell,
            recipient,
          }
        );

        if (response.msg === "Success") {
          this.$toast(response.msg, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
        } else {
          this.$toast.error(response.msg, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
        }
        console.log(response);
      }

      this.pending.autofixedSell = false;
    },

    async onLaunch(type, isFlashBot, isMixed = false) {
      this.pending[type] = true;

      if (!isFlashBot) {
        if (this.config.currentTokenPoolETH < 1.0) {
          this.$toast.error("Low Liquidity Pool . Can't Buy", {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
          this.pending[type] = false;
          return;
        }
      }

      try {
        let accounts, privateKeys;

        accounts = CopyTrade.getActiveAccounts();
        privateKeys = accounts.map((account) => account.pk);
        if (isFlashBot) {
          // accounts = this.accounts.filter((account) => account.pk);
          accounts = this.accounts.filter((account) => account.pk);
          privateKeys = accounts.map((account) => account.pk);
          privateKeys = privateKeys
            .slice(0, this.config.initCount)
            .map((account) => account.pk);
        }
        // const accounts = CopyTrade.getActiveAccounts();
        // const privateKeys = accounts
        //   .filter((account) => account.pk)
        //   .map((account) => account.pk);

        // let poolSize = this.config.poolSize; // *** Will do later ***
        if (isFlashBot && privateKeys.length < 5) {
          this.$toast.error("Should check at least 5 wallets", {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
          this.pending[type] = false;
          return;
        }

        let balances = {};
        Object.keys(this.config.balances).map((key) => {
          const wallet = accounts.find(
            (account) =>
              new ethers.Wallet(account.pk).address.toLowerCase() ===
              key.toLowerCase()
          );
          if (!wallet) return;
          balances[key] = {
            ...this.config.balances[key],
            eth: wallet.balance,
          };
        });

        console.log({
          dpk: this.config.dpk,
          minerReward: this.config.tipAmount,
          enableProc: this.config.enableProc,
          isFlashBot,
          minAmount: this.config.minAmount,
          maxAmount: this.config.maxAmount,
          buyerPvtKeys: privateKeys,
          tokenAddr: this.$route.params.address,
          isWhale: this.config.isWhale,
          isMixed: isMixed,
          balances,
          isPercent: this.config.isPercent,
          basePerGas: this.config.basePerGas,
          baseCnt: this.config.baseCnt,
          isRandom: this.config.random
        });
        const router = Web3Helper.getDexList()[this.config.factory].router;

        if (isMixed) {
          const approvePromises = accounts.map(async (account) => {
            const allowance = await this.allowance({
              account,
              contract: this.contract,
              isOriginalRouter: false,
              router,
            });
            if (BigInt(allowance) != BigInt(0)) return;
            await this.approve({
              account,
              contract: this.contract,
              isOriginalRouter: false,
              router,
            });
          });

          await Promise.all(approvePromises);
        }


        const { data: response } = await axios.post(
          `${Config.PEIN_URL}/processFlashBots`,
          {
            dpk: this.config.dpk,
            minerReward: parseFloat(this.config.tipAmount),
            enableProc: this.config.enableProc,
            isFlashBot,
            minAmount: parseFloat(this.config.minAmount),
            maxAmount: parseFloat(this.config.maxAmount),
            buyerPvtKeys: privateKeys,
            tokenAddr: this.$route.params.address,
            isWhale: this.config.isWhale,
            isMixed: isMixed,
            balances,
            isPercent: this.config.isPercent,
            basePerGas: this.config.basePerGas,
            baseCnt: this.config.baseCnt,
            sellPercent: this.config.sellPercent,
          }
        );
        if (response.msg === "Success") {
          this.$toast(response.msg, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
        } else {
          this.$toast.error(response.msg, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
        }
        console.log(response);
      } catch (e) {
        console.log(e);
      }
      this.pending[type] = false;
    },

    async onMev(type) {
      this.pending[type] = true;
      try {
        const accounts = CopyTrade.getActiveAccounts();
        const privateKeys = accounts
          .filter((account) => account.pk)
          .map((account) => account.pk);
        let balances = {};
        console.log(this.config.balances);
        Object.keys(this.config.balances).map((key) => {
          const wallet = accounts.find(
            (account) =>
              new ethers.Wallet(account.pk).address.toLowerCase() ===
              key.toLowerCase()
          );
          if (!wallet) return;
          balances[key] = {
            ...this.config.balances[key],
            eth: wallet.balance,
          };
        });

        console.log({
          minerReward: this.config.tipAmount,
          minAmount: this.config.minAmount,
          maxAmount: this.config.maxAmount,
          buyerPvtKeys: privateKeys,
          balances,
          tokenAddr: this.$route.params.address,
          basePerGas: this.config.basePerGas,
        });
        const { data: response } = await axios.post(
          `${Config.PEIN_URL}/processUnClog`,
          {
            minerReward: parseFloat(this.config.tipAmount),
            minAmount: parseFloat(this.config.minAmount),
            maxAmount: parseFloat(this.config.maxAmount),
            buyerPvtKeys: privateKeys,
            balances,
            tokenAddr: this.$route.params.address,
            basePerGas: this.config.basePerGas,
          }
        );
        if (response.msg === "Success") {
          this.$toast(response.msg, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
        } else {
          this.$toast.error(response.msg, {
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
          });
        }
        console.log(response);
      } catch (e) {
        console.log(e);
      }
      this.pending[type] = false;
    },
    async handleWatch() {
      if (!this.isWatch) {
        const details = await Web3Helper.getTokenDetails(
          this.contract.get("address")
        );
        Listener.listen(this.contract.get("address"), details.owner);
        this.isWatch = true;
      } else {
        Listener.stop();
        this.isWatch = false;
      }
    },
  },
  data() {
    return {
      pending: {
        mixtrade: false,
        enable: false,
        multibuy: false,
        mev: false,
        autobuy: false,
        autosell: false,
        autofixedSell: false,
      },
      // Auto trade
      autoTradeTimer: 0,
      autoBuyTimer: 0,
      autoSellTimer: 0,
      fetchPoolWETHTimer: null,
      nowTimer: 0,
      isAutoDeposit: false,

      sellPending: false,
      loopPending: false,
      isAutoPlaying: false,
      autoBuyIndexes: [],
      autoSellIndexes: [],
      isWatch: false,
      selector: "",
      isExpand: true,
      autoPlayingTimer: null,
      autobuyCount: 4,
      autoSellCount: 2,
      autobuyCountList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      autoSellCountList: [1, 2, 3, 4, 5],
      autoPlayingPhase: "pump",
      tradeHistory: [], // Track recent trades
    };
  },
};
</script>
<style scoped>
.expander {
  border-radius: 0.5rem;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.icon-rotate {
  transform: rotate(180deg);
}

.card-body {
  padding: 0px;
  overflow: hidden;
  height: 0px;
}

.is-expand {
  height: auto;
  padding: 1.5rem;
  padding-top: 0px;
  overflow: auto;
}

.mobile-mt {
  margin-top: 0px;
}

.mobile-gap {
  gap: 0px;
}

@media (max-width: 992px) {
  .mobile-mt {
    margin-top: 12px;
  }

  .mobile-gap {
    gap: 12px;
  }
}

@media (max-width: 768px) {
  .sticky-top {
    position: unset;
  }
}
</style>
